<template>
    <div class="modal fade" tabindex="-1" id="MudarSenha">
        <div class="modal-dialog modal-dialog-centered modal-xl">
            <div class="modal-content mudar-senha-modal">
                <div class="modal-body mudar-senha-body">
                    <header class="mudar-senha-header">
                        <div class="mudar-senha-header__text">
                            <span class="mudar-senha-header__eyebrow">Segurança</span>
                            <h3 class="mudar-senha-header__title">Redefina sua senha</h3>
                            <p class="mudar-senha-header__description">Proteja sua conta criando uma nova senha forte e exclusiva. Preencha o formulário para confirmar a alteração.</p>
                        </div>
                    </header>

                    <div class="mudar-senha-content">
                        <aside class="mudar-senha-info">
                            <div class="mudar-senha-info__icon">
                                <i class="fas fa-shield-alt"></i>
                            </div>
                            <div class="mudar-senha-info__text">
                                <strong>Boas práticas</strong>
                                <ul>
                                    <li>Use ao menos 8 caracteres com letras e números.</li>
                                    <li>Evite dados pessoais ou senhas reutilizadas.</li>
                                    <li>Atualize periodicamente para maior proteção.</li>
                                </ul>
                            </div>
                        </aside>

                        <form class="mudar-senha-form" id="formTrocaSenha">
                            <div class="mudar-senha-grid">
                                <div class="mudar-senha-form__group">
                                    <label class="mudar-senha-form__label" for="senhaAtual">Senha atual</label>
                                    <input class="mudar-senha-input" placeholder="Digite sua senha atual" type="password" id="senhaAtual" name="usuario.senhaAtual" v-model="usuario.senhaAtual" :maxlength="limiteCaracteres" required>
                                </div>

                                <div class="mudar-senha-form__group">
                                    <label class="mudar-senha-form__label" for="dsSenha">Nova senha</label>
                                    <input class="mudar-senha-input" placeholder="Crie uma nova senha" type="password" id="dsSenha" name="usuario.dsSenha" v-model="usuario.dsSenha" :maxlength="limiteCaracteres" required>
                                </div>

                                <div class="mudar-senha-form__group">
                                    <label class="mudar-senha-form__label" for="dsSenhaConfirma">Confirme a nova senha</label>
                                    <input class="mudar-senha-input" placeholder="Repita a nova senha" type="password" id="dsSenhaConfirma" name="usuario.dsSenhaConfirma" v-model="usuario.dsSenhaConfirma" :maxlength="limiteCaracteres" required>
                                </div>
                            </div>

                            <button class="mudar-senha-submit" type="button" :disabled="!liberaSalvar" @click="enviar">
                                <span>Salvar alterações</span>
                            </button>
                        </form>
                    </div>
                </div><!-- .modal-body -->
                <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3" data-bs-dismiss="modal">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg><!-- x-lg -->
                </button><!-- modal-close -->
            </div><!-- .modal-content -->
        </div><!-- .modal-dialog -->
    </div><!-- .modal -->
</template>

<script>
    import { urlApi, avisoSucesso, avisoErro } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'MudarSenha',
        data: function () {
            return {

                limiteCaracteres: 500,

                usuario: {
                    senhaAtual: null,
                    dsSenha: null,
                    dsSenhaConfirma: null,
                },

            }
        },
        props: {
            showModal: Boolean,
        },
        computed: {
            liberaSalvar() {
                if (this.usuario.senhaAtual == '' || this.usuario.senhaAtual == null) {
                    return false;
                }

                if (this.usuario.dsSenha == '' || this.usuario.dsSenha == null) {
                    return false;
                }

                if (this.usuario.dsSenhaConfirma == '' || this.usuario.dsSenhaConfirma == null) {
                    return false;
                }


                return true;
            }
        },
        methods: {
            enviar() {
                if (this.checkForm()) {
                    let $this = this;
                    axios.post(`${urlApi}/Auth/AlteraSenha`, $this.usuario)
                        .then(res => {
                            if (res.data.success) {
                                // aviso ok
                                avisoSucesso("Senha alterada com sucesso!");
                                $this.$refs['modal-mudar-senha'].hide();
                            } else {
                                avisoErro("Não foi possível alterar sua senha.");
                            }
                        })
                        .catch(res => {
                            if (res.response.data != undefined) {
                                avisoErro(res.response.data);
                            } else {
                                avisoErro(res.response.statusText);
                            }
                        });
                }
                return false;
            },

            checkForm() {
                var form = document.getElementById('formTrocaSenha')
                if (!form.checkValidity()) {
                    var tmpSubmit = document.createElement('button')
                    form.appendChild(tmpSubmit)
                    tmpSubmit.click()
                    form.removeChild(tmpSubmit)

                    return false;
                }

                if (this.limiteCaracteres > 0) {
                    if (this.usuario.senhaAtual.length > this.limiteCaracteres) {
                        avisoErro("O limite de caracteres da \"Senha\" foi ultrapassado")
                        return false;
                    }

                    if (this.usuario.dsSenha.length > this.limiteCaracteres) {
                        avisoErro("O limite de caracteres da \"Nova Senha\" foi ultrapassado")
                        return false;
                    }

                    if (this.usuario.dsSenhaConfirma.length > this.limiteCaracteres) {
                        avisoErro("O limite de caracteres da \"Confirma Senha\" foi ultrapassado")
                        return false;
                    }
                }

                if (this.usuario.dsSenha != this.usuario.dsSenhaConfirma) {
                    avisoErro("As senhas não coincidem")
                    return false;
                }
                

                return true;
            },

            load() {
                
            },

            close() {
                const myModalAlternative = new window.bootstrap.Modal('#MudarSenha');
                myModalAlternative.hide();
            }

        },
        created: function () {
            this.load();
        },
        watch: {
            showModal: function () {
                const myModalAlternative = new window.bootstrap.Modal('#MudarSenha');
                myModalAlternative.show();

                this.usuario = {
                    senhaAtual: null,
                    dsSenha: null,
                    dsSenhaConfirma: null,
                };
            },
            
        }
        
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css" scoped>
    .modal-xl {
        width: min(60vw, 880px);
        max-width: min(60vw, 880px);
        margin: 0 auto;
    }

    .mudar-senha-modal {
        border: none;
        border-radius: 28px;
        background: linear-gradient(150deg, #f8faff 0%, #eef2ff 45%, #ffffff 100%);
        box-shadow: 0 30px 80px -20px rgba(21, 38, 78, 0.25);
        position: relative;
        /*overflow: hidden;*/
    }

    .mudar-senha-body {
        padding: 40px clamp(24px, 5vw, 56px);
        display: flex;
        flex-direction: column;
        gap: 32px;
    }

    .mudar-senha-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 24px;
        position: relative;
    }

    .mudar-senha-header__text {
        display: flex;
        flex-direction: column;
        gap: 8px;
        color: #1d2533;
    }

    .mudar-senha-header__eyebrow {
        font-size: 0.75rem;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        font-weight: 600;
        color: #4c5b8f;
    }

    .mudar-senha-header__title {
        font-size: clamp(1.5rem, 2.2vw, 2rem);
        font-weight: 700;
        margin: 0;
    }

    .mudar-senha-header__description {
        margin: 0;
        font-size: 0.95rem;
        line-height: 1.6;
        color: rgba(29, 37, 51, 0.72);
    }

    .mudar-senha-content {
        display: grid;
        grid-template-columns: minmax(220px, 280px) minmax(0, 1fr);
        gap: clamp(24px, 4vw, 48px);
        align-items: flex-start;
    }

    .mudar-senha-info {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: clamp(20px, 3vw, 28px);
        border-radius: 20px;
        background: rgba(255, 255, 255, 0.82);
        box-shadow: 0 18px 40px -28px rgba(53, 61, 104, 0.35);
        border: 1px solid rgba(105, 128, 178, 0.16);
    }

    .mudar-senha-info__icon {
        width: 64px;
        height: 64px;
        border-radius: 18px;
        display: grid;
        place-items: center;
        background: rgba(76, 91, 143, 0.12);
        color: #3b4674;
        font-size: 1.9rem;
    }

    .mudar-senha-info__text strong {
        font-size: 1rem;
        color: #1f2a44;
        display: block;
        margin-bottom: 8px;
    }

    .mudar-senha-info__text ul {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: column;
        gap: 6px;
        color: rgba(59, 64, 85, 0.85);
        font-size: 0.9rem;
    }

    .mudar-senha-info__text li::before {
        content: '\2022';
        color: #4f7bff;
        font-weight: 700;
        display: inline-block;
        width: 1em;
        margin-left: -1em;
    }

    .mudar-senha-form {
        display: flex;
        flex-direction: column;
        gap: 24px;
        padding: clamp(24px, 4vw, 36px);
        border-radius: 20px;
        background: rgba(255, 255, 255, 0.88);
        box-shadow: 0 18px 40px -30px rgba(53, 61, 104, 0.35);
        border: 1px solid rgba(105, 128, 178, 0.12);
    }

    .mudar-senha-grid {
        display: grid;
        gap: 20px;
    }

    .mudar-senha-form__group {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .mudar-senha-form__label {
        font-size: 0.95rem;
        font-weight: 600;
        color: rgba(29, 37, 51, 0.85);
    }

    .mudar-senha-input {
        width: 100%;
        border-radius: 12px;
        border: 1px solid rgba(76, 91, 143, 0.2);
        background: rgba(255, 255, 255, 0.95);
        padding: 12px 16px;
        font-size: 1rem;
        color: #1d2533;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

    .mudar-senha-input:focus,
    .mudar-senha-input:focus-visible {
        outline: none;
        border-color: rgba(76, 91, 143, 0.6);
        box-shadow: 0 0 0 4px rgba(96, 119, 180, 0.18);
    }

    .mudar-senha-submit {
        border: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        border-radius: 14px;
        padding: 16px 22px;
        font-weight: 600;
        font-size: 1rem;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        background: linear-gradient(135deg, #4f7bff 0%, #2745d8 100%);
        color: #ffffff;
        box-shadow: 0 15px 30px -12px rgba(39, 69, 216, 0.55);
        transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
        cursor: pointer;
    }

    .mudar-senha-submit:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 18px 36px -14px rgba(39, 69, 216, 0.6);
        filter: brightness(1.05);
    }

    .mudar-senha-submit:disabled {
        cursor: not-allowed;
        background: linear-gradient(135deg, #b8c4ff 0%, #9baaff 100%);
        box-shadow: none;
        opacity: 0.75;
    }

    @media (max-width: 992px) {
        .modal-xl {
            width: min(90vw, 720px);
            max-width: min(90vw, 720px);
        }

        .mudar-senha-content {
            grid-template-columns: 1fr;
        }

        .mudar-senha-info {
            flex-direction: row;
            align-items: flex-start;
        }

        .mudar-senha-info__icon {
            flex-shrink: 0;
        }
    }

    @media (max-width: 576px) {
        .mudar-senha-body {
            padding: 32px 22px;
        }

        .mudar-senha-header {
            flex-direction: column;
            align-items: flex-start;
        }

        .mudar-senha-form {
            padding: 20px;
        }

        .mudar-senha-submit {
            width: 100%;
        }
    }
</style>

